import { extractTenantFromUrl } from "../utils/themeUtils";

const AMPULHETA = "ampulheta";

// Mesma chave usada em hooks/auth.jsx (`${project}:tenant`). Não importamos de lá para
// evitar dependência circular, já que este helper também é usado por services.
const TENANT_STORAGE_KEY = "@Project:tenant";

const getLoggedTenantIdentifier = () => {
  try {
    const tenant = JSON.parse(localStorage.getItem(TENANT_STORAGE_KEY) || "null");
    return String(tenant?.identificador ?? tenant?.Identificador ?? "").toLowerCase();
  } catch {
    return "";
  }
};

// O tenant Ampulheta chama a "Geração de Caixa" de "Variação de Caixa".
// Checa o tenant do usuário logado (funciona em qualquer host, inclusive localhost)
// e, como fallback, o host whitelabel bi.atfbusiness.
export const isAmpulhetaTenant = () =>
  getLoggedTenantIdentifier() === AMPULHETA || extractTenantFromUrl() === AMPULHETA;

export const getGeracaoCaixaLabel = () =>
  isAmpulhetaTenant() ? "Variação de Caixa" : "Geração de Caixa";

// Versão curta usada em legendas e tooltips de gráfico.
export const getGeracaoShortLabel = () =>
  isAmpulhetaTenant() ? "Variação" : "Geração";

// Variante com "caixa" minúsculo, usada nos relatórios de fechamento.
export const getGeracaoCaixaSentenceLabel = () =>
  isAmpulhetaTenant() ? "Variação de caixa" : "Geração de caixa";

export const getGeracaoCaixaProjetadaLabel = () =>
  `${getGeracaoCaixaLabel()} Projetada`;
